module.exports = __webpack_public_path__ + "assets/fonts/b7112fee-423a-4450-941f-32cf5cd615df.b3cac8fe.woff";